// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinning[data-v-23df9dfc]{animation:spin-data-v-23df9dfc 3s linear infinite}.spinning g[data-v-23df9dfc]{animation:changeColor-data-v-23df9dfc 1.5s infinite alternate}@keyframes spin-data-v-23df9dfc{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}@keyframes changeColor-data-v-23df9dfc{0%{fill:currentColor}to{fill:var(--green)}}", ""]);
// Exports
module.exports = exports;
